import React, {FC, useState, useEffect} from "react";
import {
    ComponentTypeID,
    IAssessment, IAssessmentTemplateGroup, IControlMeasure, ISummaryKnowledge
} from "../types/types";

import {Box, Chip, Collapse, IconButton, TableCell, TableRow, TextField} from "@material-ui/core";
import Investigations from "./investigations";
import Comments from "./comments";
import {useParams} from "react-router";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import DataGaps from "./data_gaps";
import {  useTask } from '../stateManagement/context';


interface IRouteParams {
    id: string
}



interface ISummaryKnowledgeProps {
    topLevelGroup: IAssessmentTemplateGroup
    assessments: IAssessment[]
    updateSummaryKnowledge: (summaryAssessment: ISummaryKnowledge) => void;
}




const SummaryKnowledge: FC<ISummaryKnowledgeProps> = ({
                                                          topLevelGroup,
                                                          assessments,
                                                          updateSummaryKnowledge
                              }) => {

    const [open, setOpen] = useState(false);

    const params = useParams<IRouteParams>()

    let tasks = useTask()
    const [write_access, setWriteAccess] = useState<boolean>(false);


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    const renderField = <T,>(obj: T, key: keyof T,
                             label: string,
                             type: string,
                             setObj:(obj:T) => void,
                             updateObj:(obj:T) => void) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    disabled={!write_access}
                    multiline={true}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                    }
                    }
                    onBlur={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                        updateObj(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }

    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    let alpha = 1
    let level_text = "undefined"

    let group_assessments = assessments.filter( (a) => {
        return a.assessment_template_detail?.template.group.name === topLevelGroup.name
    } )

    let min_level = 0

    group_assessments.map( ga => {
        if (!ga.assessment_template_detail)
            return
        if (min_level < ga.assessment_template_detail?.adequacy.level) {
            min_level = ga.assessment_template_detail?.adequacy.level
        }
    } )

    if (min_level === 1) {
        bcolor = "rgba(206,238,208," + alpha+ ")";
        color = "rgb(48,104,33)";
        level_text = "Adequate";
    }
    if (min_level=== 2) {
        bcolor = "rgba(252,236,166," + alpha+ ")";
        color = "rgb(152,96,34)";
        level_text = "Questionable"
    }
    if (min_level === 3) {
        bcolor = "rgba(251,84,81," + alpha+ ")";
        color = "rgb(104,4,0)";
        level_text = "Inadequate";
    }

    let missing_information = {
        color: "#535353",
        bcolor: "rgb(196,196,196)",
        alpha: 1,
        level_text: "Undefined"
    }

    if (min_level ===1) {
        missing_information = {
            bcolor : "rgba(206,238,208," + alpha+ ")",
            color : "rgb(48,104,33)",
            alpha: 1,
            level_text: "None"
        }
    }
    if (min_level > 1) {
        missing_information = {
            bcolor : "rgba(251,84,81," + alpha+ ")",
            color : "rgb(104,4,0)",
            alpha: 1,
            level_text: "Data Gaps"
        }
    }

    return (
        <>
        <TableRow  style={{backgroundColor: "#f3f3f3"}}>
            <TableCell>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                    {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </TableCell>
        <TableCell><b> {topLevelGroup.name} </b></TableCell>
        <TableCell>
            <div style={{marginLeft: "auto", marginRight: 0}}>
                <Chip
                    size="small"
                    label={level_text}
                    color="primary"
                    style={{backgroundColor:bcolor, color:color}}
                />
            </div></TableCell>
        <TableCell>
            <div style={{marginLeft: "auto", marginRight: 0}}>
                <Chip
                    size="small"
                    label={missing_information.level_text}
                    color="primary"
                    style={{backgroundColor:missing_information.bcolor, color:missing_information.color}}
                />
            </div></TableCell>
        <TableCell>{topLevelGroup.uuid && <Comments parent_uuid={parseInt(params.id) * 100000000 + topLevelGroup.uuid} type_id={ComponentTypeID.SummaryOfKnowledge}/>}</TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}colSpan={1}/>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                {topLevelGroup.uuid && <DataGaps assessment_template_group_id={topLevelGroup.uuid}/>}
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
        </>

    )
}

export default SummaryKnowledge


